import {
  AnimatePresence,
  motion,
  useMotionValue,
  useTransform,
  animate,
} from "framer-motion";
import { useEffect, useState } from "react";
import CursorBlinker from "./../components/CursorBlinker";
import { Link } from "react-router-dom";

const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = [
    "/hero/one_50.jpg",
    "/hero/two_50.jpg",
    "/hero/three_50.jpg",
    "/hero/four_50.jpg",
  ];

  const imageVariants = {
    hidden: {
      scale: 1.2,
      opacity: 0,
    },
    visible: {
      scale: 1,
      opacity: 1,
      transition: {
        scale: { duration: 10, ease: "linear" },
        opacity: { duration: 2, ease: "easeInOut" },
      },
    },
    exit: {
      opacity: 0,
      transition: { duration: 2 },
    },
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const textIndex = useMotionValue(0);
  const texts = [
    "Application  Development! ",
    "Website  Development! ",
    "E-commerce  Solutions! ",
    "AI  Integrations! ",
    "Cloud  Solutions! ",
  ];

  const baseText = useTransform(textIndex, (latest) => texts[latest] || "");
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  const displayText = useTransform(
    [baseText, rounded],
    ([latestText, latestCount]) => {
      return latestText.slice(0, latestCount);
    },
  );
  const updatedThisRound = useMotionValue(true);

  useEffect(() => {
    animate(count, 30, {
      type: "tween",
      duration: 2,
      ease: "easeInOut",
      repeat: Infinity,
      repeatType: "reverse",
      repeatDelay: 1,
      onUpdate(latest) {
        if (updatedThisRound.get() === true && latest > 0) {
          updatedThisRound.set(false);
        } else if (updatedThisRound.get() === false && latest === 0) {
          if (textIndex.get() === texts.length - 1) {
            textIndex.set(0);
          } else {
            textIndex.set(textIndex.get() + 1);
          }
          updatedThisRound.set(true);
        }
      },
    });
  }, []);

  return (
    <div className="relative h-screen w-full overflow-hidden bg-[#0B0F19]">
      <AnimatePresence mode="wait">
        <motion.img
          key={currentImage}
          src={images[currentImage]}
          className="absolute inset-0 object-cover w-full h-full"
          variants={imageVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        />
      </AnimatePresence>

      <div className="absolute inset-0 bg-gradient-to-r from-[#0B0F19] via-[#0B0F19]/60 to-transparent z-10" />

      <div className="relative z-20 h-full flex flex-col justify-center px-4 sm:px-6 lg:px-24 max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}>
          <h2 className="text-[#018CF1] font-black uppercase tracking-[0.2em] sm:tracking-[0.3em] mb-3 md:mb-4 text-xs sm:text-sm md:text-lg">
            Digital Transformation Leader
          </h2>

          <h1 className="text-white text-2xl sm:text-3xl md:text-4xl lg:text-[45px] xl:text-[52px] font-black uppercase italic leading-[1.1] sm:leading-[1.1] tracking-[-0.04em] max-w-full text-left">
            <span className="block w-full">Elevate Your Landscape with</span>

            <div className="flex justify-start items-center w-full flex-wrap sm:flex-nowrap">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white via-white to-gray-500 whitespace-nowrap">
                OUR&nbsp;
              </span>

              <span className="text-[#018CF1] inline-flex items-center min-h-[1.2em]">
                <motion.span className="whitespace-pre-wrap text-xl sm:text-2xl md:text-3xl lg:text-4xl">
                  {displayText}
                </motion.span>
                <CursorBlinker />
              </span>
            </div>
          </h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
            className="text-gray-400 mt-6 md:mt-8 max-w-full sm:max-w-[500px] text-sm md:text-lg leading-relaxed font-medium px-1">
            Empowering businesses in Myanmar with cutting-edge technology and
            seamless digital integration since 2018.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2 }}
            className="mt-8 md:mt-10 flex gap-3 md:gap-4">
            <div className="flex flex-wrap gap-3 md:gap-4 justify-center sm:justify-start">
              <Link to="/about">
                <button className="bg-[#018CF1] text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-black uppercase tracking-tighter text-sm md:text-base hover:scale-105 transition-transform shadow-[0_0_20px_rgba(1,140,241,0.3)]">
                  View About Us
                </button>
              </Link>

              <Link to="/services">
                <button className="border border-white/20 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-black uppercase tracking-tighter text-sm md:text-base hover:bg-white hover:text-black transition-all">
                  Our Services
                </button>
              </Link>

              <Link to="/products">
                <button className="border border-white/20 text-white px-6 md:px-8 py-3 md:py-4 rounded-full font-black uppercase tracking-tighter text-sm md:text-base hover:bg-white hover:text-black transition-all">
                  Our Products
                </button>
              </Link>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
